import { useCallback, useMemo } from "react"

import { UseTableRowSelectionProps, UseTableRowSelectionRes } from "./types"

export function useTableRowSelection<T>({
  state,
  dispatch,
}: UseTableRowSelectionProps<T>): UseTableRowSelectionRes<T> {
  const select = useCallback<UseTableRowSelectionRes<T>["select"]>(
    (dataToSelect: T[]) => {
      dispatch({
        type: "select_rows",
        rowData: dataToSelect,
      })
    },
    [dispatch]
  )

  const toggleAllSelected = useCallback<
    UseTableRowSelectionRes<T>["toggleAllSelected"]
  >(() => {
    dispatch({ type: "toggle_all_selected" })
  }, [dispatch])

  const clearSelected = useCallback<
    UseTableRowSelectionRes<T>["clearSelected"]
  >(() => {
    dispatch({ type: "clear_selected" })
  }, [dispatch])

  const selected = useMemo<UseTableRowSelectionRes<T>["selected"]>(
    () => Array.from(state.selectedByKey.values()),
    [state.selectedByKey]
  )

  return {
    isAllSelected: state.isAllSelected,
    selected,
    select,
    toggleAllSelected,
    clearSelected,
  }
}
